import React from "react";

import { css } from "@emotion/react";

import { ListTechSpecSection, type TranslatedValue } from "@swo/storefront";
import { readonlyArray, string } from "fp-ts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { FONTS, fontSize } from "../../../styles/fonts";
import { T } from "../../../components/T";

export function ListSection(props: ListTechSpecSection & { differencesHighlight: Array<boolean> | undefined }) {
  return (
    <>
      {props.attributes.map(({ values, label, __key }, idx) => {
        return (
          <Attribute
            key={__key.concat(idx.toString())}
            values={values.map(v => (typeof v === "string" ? v : v.value))}
            label={typeof label === "string" ? label : label?.value}
            highlighted={typeof props.differencesHighlight !== "undefined" && props.differencesHighlight[idx]!}
          />
        );
      })}
    </>
  );
}

const uniq = readonlyArray.uniq(string.Eq);

export function Attribute(props: {
  values: Array<string | TranslatedValue>;
  label?: string | TranslatedValue;
  highlighted: boolean;
}) {
  return (
    <div css={wrapperStyles} className={props.highlighted ? "highlighted" : undefined}>
      {!props.values.length ? (
        <span css={styles} className={"empty"}>
          —
        </span>
      ) : (
        uniq(props.values.map(v => (typeof v === "string" ? v : v.value))).map(attr => (
          <span key={attr} css={styles}>
            {attr}
          </span>
        ))
      )}
      {props.label && (
        <span css={labelStyles}>
          <T>{props.label}</T>
        </span>
      )}
    </div>
  );
}

const styles = [
  FONTS.SwarovskiFutura500,
  fontSize.x25,
  css`
    text-align: center;

    .highlighted > &:not(.empty) {
      color: ${CSS_COLORS.Green};
    }
  `,
];

const labelStyles = [
  FONTS.SwarovskiFutura300,
  fontSize.x2s,
  css`
    color: ${CSS_COLORS.Black};

    line-height: 1;
    margin-top: -2px;
    margin-bottom: 2px;

    text-align: center;
  `,
];

const wrapperStyles = css`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
`;
